// ====================
// components/Footer.js
// ====================

import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <h3>Nicole Amaral</h3>
            <p>Computer Science & Cybersecurity Student</p>
          </div>
          <div className="footer-right">
            <p>&copy; 2025 Nicole Amaral. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;